import axios from 'axios';

const http = axios.create();

let context = null;

http.defaults.timeout = 4000;

http.interceptors.response.use(
	config => {
		if (config.headers['x-token']) {
			console.log('X-TOKEN');
			context.dispatch('user/setNewToken', config.headers['x-token']);
			/**
			 * The x-token means that the server is giving a new token meant to update the user
			 * However we still need to add proper logic to this.
			 * Right now, if the line below is uncommented, this will result in a really bad infinite loop between updatetoken -> getdata -> error -> x-token -> updatetoken
			 */
			//context.dispatch("user/updateToken", config.headers["x-token"]);
		}
		return config;
	},
	err => {
		if (err.response) {
			serverError(err);
		} else if (err.request) {
			clientError(err);
		} else {
			genericError(err);
		}
	}
);

function clientError(err) {
	/**
	 * Disabled this cuz it was too obnoxious.
	 * v0.5.2
	 */
	//context.dispatch("message/onNetworkError", "client");
}

function serverError(err) {
	if (err.response.status === 401) {
		if (context.getters['user/isAuth']) {
			// Most likely something went wrong on signup or login
			context.dispatch('message/onNetworkError', 'auth:timeout');
			context.dispatch('user/relogin');
		}
	} else if (err.response.status === 400) {
		// dont do anything
		// let the ui handle
	} else {
		context.dispatch('message/onNetworkError', 'server');
	}
}

function genericError(err) {
	context.dispatch('message/onNetworkError');
}

async function sendRequest(method, apiPath, data) {
	if (method === 'delete') {
		var opts = {
			url: apiPath,
			method: method,
			data: data
		};
		await http.request(opts);
	} else {
		return await http[method](apiPath, data);
	}
}

function setHeader(key, value) {
	var type = 'common';
	http.defaults.headers[type][key] = value;
}

function setUrl(url) {
	http.defaults.baseURL = url;
}

function setContext(ctx) {
	context = ctx;
}

export default {
	setContext: setContext,
	setUrl: setUrl,
	setHeader: setHeader,
	request: sendRequest
};
